import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div className="text-center py-20">
        <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">
          Unleash Your Creativity with AI
        </h1>
        <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
          Transform your ideas into stunning artwork using the latest AI technology
        </p>
        <Link
          to="/generate"
          className="bg-blue-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          Get Started
        </Link>
      </div>

      <div className="bg-gray-800 rounded-lg p-8 mt-8 text-center shadow-lg">
        <h2 className="text-3xl font-bold mb-4 text-blue-400">Welcome to AI Image Generator</h2>
        <p className="text-lg text-gray-200 mb-4">
          Instantly turn your ideas into stunning images using the power of artificial intelligence. 
          Just describe what you want, choose your favorite style, and let our AI do the magic!
        </p>
        <ul className="text-gray-300 mb-4 list-disc list-inside text-left max-w-xl mx-auto">
          <li>Generate unique images for your projects, social media, or personal use.</li>
          <li>Choose from multiple styles: Realistic, Artistic, Cartoon, and Anime.</li>
          <li>No design skills required – just your imagination!</li>
          <li>Fast, easy, and free to use.</li>
        </ul>
        <p className="text-gray-400 text-sm">
          Start now and explore the endless possibilities of AI-powered creativity.
        </p>
      </div>

      {/* Features Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 py-16">
        <div className="bg-gray-800 p-6 rounded-lg">
          <div className="text-blue-500 text-4xl mb-4">🎨</div>
          <h3 className="text-xl font-semibold mb-2">Unique Image Generation</h3>
          <p className="text-gray-400">
            Create unique and distinctive images using simple text descriptions
          </p>
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <div className="text-blue-500 text-4xl mb-4">⚡</div>
          <h3 className="text-xl font-semibold mb-2">Fast Generation</h3>
          <p className="text-gray-400">
            Get your images in seconds with high quality
          </p>
        </div>
        <div className="bg-gray-800 p-6 rounded-lg">
          <div className="text-blue-500 text-4xl mb-4">🔄</div>
          <h3 className="text-xl font-semibold mb-2">Multiple Options</h3>
          <p className="text-gray-400">
            Choose from a variety of styles and sizes
          </p>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="py-16">
        <h2 className="text-3xl font-bold text-center mb-12">How It Works</h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-xl font-bold">1</span>
            </div>
            <h3 className="font-semibold mb-2">Write Your Description</h3>
            <p className="text-gray-400">Write a detailed description of the image you want</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-xl font-bold">2</span>
            </div>
            <h3 className="font-semibold mb-2">Choose Options</h3>
            <p className="text-gray-400">Select the appropriate size and style</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-xl font-bold">3</span>
            </div>
            <h3 className="font-semibold mb-2">Wait for Generation</h3>
            <p className="text-gray-400">Let the AI do its magic</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-600 w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-xl font-bold">4</span>
            </div>
            <h3 className="font-semibold mb-2">Download Image</h3>
            <p className="text-gray-400">Download and save or share your image</p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center py-16">
        <h2 className="text-3xl font-bold mb-6">Ready to Start?</h2>
        <p className="text-gray-300 mb-8">
          Start creating amazing artwork using AI today
        </p>
        <Link
          to="/generate"
          className="bg-blue-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors"
        >
          Try Now
        </Link>
      </div>
    </div>
  );
}

export default Home; 